@if (lightbox.isOpen()) {
  <div class="ktc-lightbox" (click)="lightbox.close()">
    <button type="button" class="ktc-lightbox__close" (click)="lightbox.close()" aria-label="Close">&times;</button>

    @if (lightbox.album().length > 1) {
      <button type="button" class="ktc-lightbox__nav ktc-lightbox__nav--prev" (click)="prev($event)" aria-label="Previous">&#10094;</button>
      <button type="button" class="ktc-lightbox__nav ktc-lightbox__nav--next" (click)="next($event)" aria-label="Next">&#10095;</button>
    }

    <figure class="ktc-lightbox__figure" (click)="$event.stopPropagation()">
      <img class="ktc-lightbox__img" [src]="current()?.src" [alt]="caption()" draggable="false">

      @if (caption()) {
        <figcaption class="ktc-lightbox__caption">{{ caption() }}</figcaption>
      }

      @if (lightbox.album().length > 1) {
        <span class="ktc-lightbox__counter">{{ lightbox.index() + 1 }} / {{ lightbox.album().length }}</span>
      }
    </figure>
  </div>
}
